import {UIArtefakt} from './uiArtefakt';

export enum EnumGruppeTechnischeSteuerung{
  AVVEINWILLIGUNG = 'AvvEinwilligung',
  ANGEBOTSERSTELLUNGMOEGLICHJNVALIDIERUNG = 'AngebotserstellungMoeglichJNValidierung',
  ELEKTRONISCHE_UNTERSCHRIFT_VALIDIERUNG = 'ElektronischeUnterschriftValidierung',
  AUSBLENDENBEIUSERANONYM = 'AusblendenBeiUserAnonym',
  CREATE_ANGEBOT = 'CreateAngebot'
}

export function hasAvvEinwilligung(isInGruppeAvvEinwilligung: boolean,
                                   avvEinwilligungImAntrag: UIArtefakt,
                                   isVermittlerdatenGesetzt: boolean): boolean {
  if (!avvEinwilligungImAntrag || !isInGruppeAvvEinwilligung) {
    return true;
  }
  return isVermittlerdatenGesetzt && !!avvEinwilligungImAntrag.WertEingabe;
}
